import { PartnerGame } from "interfaces/partner-game";
import Carousel from "react-multi-carousel";
import shimmerStyles from "components/pool-details/entries/loading-bet-form/styles.module.scss";
import styles from "../event-filters/featured-events-carousel/featured-events-carousel.module.scss";
import { getPartnerGameEmbedUrl } from "utils/backend-path-builders";
import { getGroupState, requestToJoinGroup } from "state/slices/group-slice";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { getRequest } from "utils/httpClient";
import { setEmbedUrl } from "state/slices/partner-game-slice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "hooks/auth";
import { showSignIn } from "state/slices/login-modals-slice";
import JoinGroupModal from "home/join-group-button/join-group-modal";
import { UserGroupMembershipStatus } from "utils/userGroupMembershipStatus";

interface Props {
  games: PartnerGame[];
}
const PartnerGamePresenter = ({ games }: Props) => {
  const { id: groupId, status } = useAppSelector(getGroupState);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [selectedGameId, setSelectedGameId] = useState<string | null>(null);
  const [showJoinGroupModal, setShowJoinGroupModal] = useState(false);
  const userHasJoinedGroup = status === UserGroupMembershipStatus.APPROVED;
  const auth = useAuth();

  const getEmbedUrl = async (game: PartnerGame) => {
    if (!auth.signedIn) {
      dispatch(showSignIn());
      return;
    }

    if (!userHasJoinedGroup) {
      setShowJoinGroupModal(true);
      return;
    }

    const path = getPartnerGameEmbedUrl(groupId, game.id);
    getRequest(path).then((data) => {
      dispatch(setEmbedUrl(data.embed_url));
      navigate("/partner-game");
    });
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 2000 },
      items: 10,
    },
    largeDesktop: {
      breakpoint: { max: 2000, min: 1500 },
      items: 7,
    },
    desktop: {
      breakpoint: { max: 1500, min: 1000 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1000, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
    },
  };
  return (
    <div style={{ width: "100%" }}>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        partialVisible={false}
        keyBoardControl={true}
        responsive={responsive}
      >
        {games.map((game) => {
          const isSelected = selectedGameId === game.id;

          return (
            <div
              data-testid="game-card"
              key={game.id}
              className={styles.cardContainer}
              onClick={() => {
                setSelectedGameId(game.id);
                getEmbedUrl(game);
              }}
            >
              <div
                style={{
                  height: "100%",
                  borderRadius: 10,
                }}
                className={shimmerStyles.animatedBackground}
              >
                <img
                  style={{
                    border: isSelected ? "2px solid white" : "",
                    width: "100%",
                  }}
                  className={styles.image}
                  src={game.logo}
                  alt={""}
                />
              </div>
            </div>
          );
        })}
      </Carousel>
      <JoinGroupModal
        acceptAndJoin={() => {
          dispatch(requestToJoinGroup(groupId));
          setShowJoinGroupModal(false);
        }}
        show={showJoinGroupModal}
        close={() => setShowJoinGroupModal(false)}
      />
    </div>
  );
};

export default PartnerGamePresenter;
